import { createCommand } from '@commander-js/extra-typings';
import type { CommandServices } from '@wix/cli-command-contract';
import { createI18nT } from '../i18n.js';

export const uninstallCommand = (
  services: CommandServices,
  cliVersion: string
) => {
  const t = createI18nT();

  return createCommand('uninstall')
    .description(t('site_uninstall_command_def.description'))
    .argument('<package>', t('site_uninstall_command_def.argument.package'))
    .option('--yarn', t('site_uninstall_command_def.option.yarn'))
    .option('--npm', t('site_uninstall_command_def.option.npm'))
    .action(async (packageName, opts, command) => {
      const { runCommand } = await import('./run-command.js');
      const { uninstall } = await import('../uninstall/index.js');

      await runCommand(command, services, cliVersion, (model) =>
        uninstall(model, services, opts, packageName)
      );
    });
};
